import { withSessionRefresh } from "api/SessionAuth";
import { authAxios } from "utils/axios";

/** Every sign-in method, in the order the profile card shows them. */
export const METHOD_KEYS = ["email", "google", "telegram"] as const;
export type MethodKey = typeof METHOD_KEYS[number];

/** One sign-in method as the API reports it. The site never infers these. */
export interface SignInMethodStatus {
  linked: boolean;
  linkable: boolean;
  display: string | null;
}

export type SignInMethodsData = Record<MethodKey, SignInMethodStatus>;

/**
 * Ask for a confirmation letter to attach an email to the signed-in account.
 * A 200 says nothing about whether the address was free. `expectedUserId` is the
 * account the page rendered; for any other session the server writes nothing.
 */
export const changeEmail = async (address: string, expectedUserId: number): Promise<void> => {
  await withSessionRefresh(() =>
    authAxios.post("/auth/change_email", {
      new_email: address,
      expected_user_id: expectedUserId,
    })
  );
};

/** Confirm the letter's token, for the session that asked for it. */
export const verifyEmail = async (token: string, expectedUserId: number): Promise<void> => {
  await withSessionRefresh(() =>
    authAxios.post("/auth/verify_email", {
      token,
      expected_user_id: expectedUserId,
    })
  );
};
